import {ACTION_CODE} from './_actionCode';
import {TrainingProductOriginService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_TRAINING_OBJECTIVE';

export async function getAllTrainingProductOrigin(
    userData: UserState["userProfileData"],
    search = "",
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllTrainingProductOrigin - Start');

        const getAllTrainingProductOriginResult = await TrainingProductOriginService.getAllTrainingProductOrigin(userData, search, page);

        LoggerService.logInfo('Action - getAllTrainingProductOrigin - Success');

        return ResultModel.newSuccessResult(getAllTrainingProductOriginResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllTrainingProductOrigin - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des origines des produits',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
